import { InfoBox } from "~/components/Backroom/InfoBox";
import { RadioGroup } from "~/components/Backroom/RadioGroup";
import ButtonGroup from "../ButtonGroup";
import { CurrentStepProps } from "../getSideMenuItems";
import InfoModal from "../../Infomodal";
import { Inputs } from "../useUpsertProductForm";
import Input from "~/components/Backroom/Input";

export const stockPreviewImages = [
  {
    id: "stock1",
    title: "Vist på produktsiden",
    src: "/assets/images/previews/products/product-stock/desktop.png",
    alt: "Placering af lager status på produktsiden",
    width: 340,
    height: 420,
  },
  {
    id: "stock2",
    title: "Vist på produktsiden på mobil",
    src: "/assets/images/previews/products/product-stock/mobil.png",
    alt: "Placering af lager status på produktsiden på mobil",
    width: 200,
    height: 500,
  },
];

export const FIELDS: Array<keyof Inputs> = [
  "stockStatus",
  "showWhenNotInStock",
  "showContactAboutStock",
  "isUnique",
  "externalUrl",
];

export const StockStep = (props: CurrentStepProps) => {
  const { stepId, form, onContinue, isEditing, onStepChange, isSubmitting } =
    props;
  const { control, register, trigger, reset, watch, formState: { errors } } = form;

  const stockStatus = watch("stockStatus");
  const showWhenNotInStock = watch("showWhenNotInStock");

  const beforeContinue = async (options?: { shouldExitEditing?: boolean }) => {
    const isValid = await trigger(FIELDS);

    if (isValid) {
      onContinue(stepId, { visibleFields: FIELDS, ...options });
      isEditing && reset({}, { keepValues: true });
    }
  };

  return (
    <>
      <h1 className="text-3xl mb-5">Lagerbeholdning</h1>
      <p className="mb-12">
        Angiv om dit produkt er på lager og klar til at blive handlet.
      </p>

      <div className="flex flex-col gap-y-1.5 mb-12">
        <label id="stockStatusLabel">Er produktet på lager?</label>
        <RadioGroup
          id="stockStatus"
          aria-describedby="stockStatusLabel"
          control={control}
        >
          <RadioGroup.Item value="inStock">Ja (flere)</RadioGroup.Item>
          <RadioGroup.Item value="unique">Unika (enkelt)</RadioGroup.Item>
          <RadioGroup.Item value="notInStock">Nej</RadioGroup.Item>
        </RadioGroup>
      </div>

      {stockStatus === "notInStock" ? (
        <div className="flex flex-col gap-y-1.5 mb-12">
          <InfoModal
            id="showWhenNotInStockDescription"
            label="Skal produktet vises i din butik alligevel?"
            htmlFor="showWhenNotInStock"
          >
            Dit produkt vil stadig blive vist i din butik, men vil blive
            markeret som 'Ikke på lager', og det kan ikke købes.
          </InfoModal>

          <RadioGroup id="showWhenNotInStock" control={control}>
            <RadioGroup.Item id="showWhenNotInStock" value="yes">
              Ja
            </RadioGroup.Item>
            <RadioGroup.Item id="showWhenNotInStock" value="no">
              Nej
            </RadioGroup.Item>
          </RadioGroup>
        </div>
      ) : null}

      {stockStatus === "notInStock" && showWhenNotInStock === "yes" ? (
        <div className="flex flex-col gap-y-1.5 mb-12">
          <InfoModal
            id="showContactAboutStockDescription"
            label="Skal 'Kontakt sælger' funktion vises?"
            htmlFor="showContactAboutStock"
          >
            Ved siden af 'Ikke på lager' vil der blive vist et link til dine
            kontaktinformationer.
            <br />
            På den måde kan kunden let tage kontakt for at høre mere om
            lagerbeholdning.
          </InfoModal>

          <RadioGroup id="showContactAboutStock" control={control}>
            <RadioGroup.Item id="showContactAboutStock" value="yes">
              Ja
            </RadioGroup.Item>
            <RadioGroup.Item id="showContactAboutStock" value="no">
              Nej
            </RadioGroup.Item>
          </RadioGroup>
        </div>
      ) : null}

      <div className="flex flex-col gap-y-1.5 mb-12">
        <Input
          id="externalUrl"
          label="Har du en egen webshop? Tilføj et link til produktet her (valgfrit)"
          placeholder="https://minwebshop.dk/produkt"
          register={register}
          error={errors.externalUrl}
          className="mb-1"
        />
        <p className="text-xs text-secondary-500">Butik Danmark tjekker dagligt om produktet stadig er tilgængeligt.
              Registreres produktet som udsolgt 2 dage i træk, sættes det automatisk som kladde og du modtager en e-mail.</p>
      </div>

      <div className="flex flex-col-reverse lg:flex-col gap-12">
        <InfoBox>
          <ul className="list-disc pl-6">
            <li>
              Vælger du at lade dit produkt vise, selvom det ikke er på lager,
              kan du i produktbeskrivelsen med fordel skrive, hvornår du
              forventer det er på lager igen.
            </li>
            <li>
              Hvis du ønsker at fjerne et produkt midlertidigt fra din butik,
              kan det gøres ved at klikke på de tre prikker i produktoversigten
              og skifte status til "Skjult".
            </li>
            <li>
              Unika-varer bliver markeret som "Unika". Når en kunde køber en
              unika-vare, vil den automatisk blive markeret som ikke på lager.
            </li>
          </ul>
        </InfoBox>
        <ButtonGroup
          isEditing={isEditing}
          onContinue={beforeContinue}
          onStepChange={onStepChange}
          form={form}
          stepId={stepId}
          isSubmitting={isSubmitting}
        />
      </div>
    </>
  );
};
